module.exports = __webpack_public_path__ + "static/media/signup3.b2ad13ed.svg";